import "./App.css";
import FilterAPU from "./components/FilterAPU";

function App() {
    return <FilterAPU />;
}

export default App;
